<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">My deepest thanks to those who taught me all about Youngstown: Chief James T. McBride, Sheriff Duke Wellington, and Bob O’Malley.</p>
<p class="tx">To the Doctors at the Cleveland Clinic: Michael Rocco, A. Marc Gillinov, and Robert Juhasz, who taught me how to get my wheels back on the track.</p>
<p class="tx">And always and forever to Holly Albin, who teaches me each day about love, friendship, loyalty, and courage.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?49c646b4